import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import { io } from "socket.io-client";
import happilogo from '../../assets/happi_h_logo.png'
import Accordion from 'react-bootstrap/Accordion';


import moment from "moment";
let BASE_URL = 'https://mis-api.happimobiles.com';
const socket = io("https://mis-api.happimobiles.com", { withCredentials: true, });

// Define number of rows and columns
const ROWS = 10;
const COLS = 10;

const Reports = ({ data }) => {
  console.log("data", data)
  const [cells, setCells] = useState(Array.from({ length: ROWS }, () => Array(COLS).fill("")));
  const [reportsData, setReportsData] = useState([
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Suresh",
      "branch_name": "ADILABAD",
      "ftd_target": "3612.90",
      "ftd_achieved": 6573,
      "mtd_target": "90322.50",
      "mtd_achieved": 3713,
      "lmtd_achieved": 312995,
      "lmtd_target": "36129.00",
      "month_target": 112000,
      "FTD Grw (+/-)": "82",
      "MTD Grw (+/-)": "-96",
      "LMTD Grw (+/-)": "766",
      "projection": "4604",
      "projection_avg_day": "149",
      "transaction_date": "2024-11-25T00:00:00.000Z",
      "current_time": "15:48:21.69756+05:30",
      "current_date": "2024-11-29T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Platinum",
      "asm": "Dattu",
      "branch_name": "AMEERPET",
      "ftd_target": "4193.55",
      "ftd_achieved": -25622,
      "mtd_target": "104838.75",
      "mtd_achieved": -523935,
      "lmtd_achieved": -102927,
      "lmtd_target": "41935.50",
      "month_target": 130000,
      "FTD Grw (+/-)": "-711",
      "MTD Grw (+/-)": "-600",
      "LMTD Grw (+/-)": "-345",
      "projection": "-649679",
      "projection_avg_day": "-20957",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Platinum",
      "asm": "Raghav",
      "branch_name": "ANANTAPUR",
      "ftd_target": "4000.00",
      "ftd_achieved": -17284,
      "mtd_target": "100000.00",
      "mtd_achieved": -220508,
      "lmtd_achieved": 287485,
      "lmtd_target": "40000.00",
      "month_target": 124000,
      "FTD Grw (+/-)": "-532",
      "MTD Grw (+/-)": "-321",
      "LMTD Grw (+/-)": "619",
      "projection": "-273430",
      "projection_avg_day": "-8820",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Chary",
      "branch_name": "ASRAONAGAR",
      "ftd_target": "1677.42",
      "ftd_achieved": -9248,
      "mtd_target": "41935.50",
      "mtd_achieved": -280914,
      "lmtd_achieved": -172727,
      "lmtd_target": "16774.20",
      "month_target": 52000,
      "FTD Grw (+/-)": "-651",
      "MTD Grw (+/-)": "-770",
      "LMTD Grw (+/-)": "-1130",
      "projection": "-348333",
      "projection_avg_day": "-11237",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Dattu",
      "branch_name": "ATTAPUR",
      "ftd_target": null,
      "ftd_achieved": -21479,
      "mtd_target": null,
      "mtd_achieved": -375906,
      "lmtd_achieved": -252779,
      "lmtd_target": null,
      "month_target": 0,
      "FTD Grw (+/-)": "-100",
      "MTD Grw (+/-)": "-100",
      "LMTD Grw (+/-)": "-100",
      "projection": "-466123",
      "projection_avg_day": "-15036",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Platinum",
      "asm": "Chary",
      "branch_name": "BODUPPAL",
      "ftd_target": "4645.16",
      "ftd_achieved": -14434,
      "mtd_target": "116129.00",
      "mtd_achieved": -246796,
      "lmtd_achieved": -40291,
      "lmtd_target": "46451.60",
      "month_target": 144000,
      "FTD Grw (+/-)": "-411",
      "MTD Grw (+/-)": "-313",
      "LMTD Grw (+/-)": "-187",
      "projection": "-306027",
      "projection_avg_day": "-9872",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Prasad",
      "branch_name": "BHIMAVARAM",
      "ftd_target": "2677.42",
      "ftd_achieved": 10166,
      "mtd_target": "66935.50",
      "mtd_achieved": -111029,
      "lmtd_achieved": 175226,
      "lmtd_target": "26774.20",
      "month_target": 83000,
      "FTD Grw (+/-)": "280",
      "MTD Grw (+/-)": "-266",
      "LMTD Grw (+/-)": "554",
      "projection": "-137676",
      "projection_avg_day": "-4441",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Titanium",
      "asm": "Dattu",
      "branch_name": "CHANDANAGAR",
      "ftd_target": "12161.29",
      "ftd_achieved": -25159,
      "mtd_target": "304032.25",
      "mtd_achieved": -364377,
      "lmtd_achieved": 319133,
      "lmtd_target": "121612.90",
      "month_target": 377000,
      "FTD Grw (+/-)": "-307",
      "MTD Grw (+/-)": "-220",
      "LMTD Grw (+/-)": "162",
      "projection": "-451827",
      "projection_avg_day": "-14575",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Hanumanth",
      "branch_name": "CHINTAL",
      "ftd_target": "2387.10",
      "ftd_achieved": -9869,
      "mtd_target": "59677.50",
      "mtd_achieved": -155128,
      "lmtd_achieved": 115685,
      "lmtd_target": "23871.00",
      "month_target": 74000,
      "FTD Grw (+/-)": "-513",
      "MTD Grw (+/-)": "-360",
      "LMTD Grw (+/-)": "385",
      "projection": "-192359",
      "projection_avg_day": "-6205",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Titanium",
      "asm": "Prasad",
      "branch_name": "DABAGARDENS",
      "ftd_target": "14225.81",
      "ftd_achieved": -3749,
      "mtd_target": "355645.25",
      "mtd_achieved": -190515,
      "lmtd_achieved": 619028,
      "lmtd_target": "142258.10",
      "month_target": 441000,
      "FTD Grw (+/-)": "-126",
      "MTD Grw (+/-)": "-154",
      "LMTD Grw (+/-)": "335",
      "projection": "-236239",
      "projection_avg_day": "-7621",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Chary",
      "branch_name": "DILSUKHNAGAR",
      "ftd_target": "2838.71",
      "ftd_achieved": -16336,
      "mtd_target": "70967.75",
      "mtd_achieved": -334658,
      "lmtd_achieved": -90254,
      "lmtd_target": "28387.10",
      "month_target": 88000,
      "FTD Grw (+/-)": "-675",
      "MTD Grw (+/-)": "-572",
      "LMTD Grw (+/-)": "-418",
      "projection": "-414976",
      "projection_avg_day": "-13386",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Raghav",
      "branch_name": "DHARMAVRAM",
      "ftd_target": "2451.61",
      "ftd_achieved": -2917,
      "mtd_target": "61290.25",
      "mtd_achieved": -98369,
      "lmtd_achieved": 90654,
      "lmtd_target": "24516.10",
      "month_target": 76000,
      "FTD Grw (+/-)": "-219",
      "MTD Grw (+/-)": "-260",
      "LMTD Grw (+/-)": "270",
      "projection": "-121978",
      "projection_avg_day": "-3935",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Chary",
      "branch_name": "ECIL",
      "ftd_target": "258.06",
      "ftd_achieved": -9163,
      "mtd_target": "6451.50",
      "mtd_achieved": -137318,
      "lmtd_achieved": -35760,
      "lmtd_target": "2580.60",
      "month_target": 8000,
      "FTD Grw (+/-)": "-3651",
      "MTD Grw (+/-)": "-2228",
      "LMTD Grw (+/-)": "-1486",
      "projection": "-170274",
      "projection_avg_day": "-5493",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Titanium",
      "asm": "Satish",
      "branch_name": "ELURU",
      "ftd_target": "5870.97",
      "ftd_achieved": 250,
      "mtd_target": "146774.25",
      "mtd_achieved": -229369,
      "lmtd_achieved": 549428,
      "lmtd_target": "58709.70",
      "month_target": 182000,
      "FTD Grw (+/-)": "-96",
      "MTD Grw (+/-)": "-256",
      "LMTD Grw (+/-)": "836",
      "projection": "-284418",
      "projection_avg_day": "-9175",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Suresh",
      "branch_name": "GODHAVARIKHANI",
      "ftd_target": "2032.26",
      "ftd_achieved": 56,
      "mtd_target": "50806.50",
      "mtd_achieved": -172240,
      "lmtd_achieved": 53877,
      "lmtd_target": "20322.60",
      "month_target": 63000,
      "FTD Grw (+/-)": "-97",
      "MTD Grw (+/-)": "-439",
      "LMTD Grw (+/-)": "165",
      "projection": "-213578",
      "projection_avg_day": "-6890",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Platinum",
      "asm": "Prasad",
      "branch_name": "GAJUWAKA",
      "ftd_target": "1064.52",
      "ftd_achieved": -9876,
      "mtd_target": "26613.00",
      "mtd_achieved": -73130,
      "lmtd_achieved": 677192,
      "lmtd_target": "10645.20",
      "month_target": 33000,
      "FTD Grw (+/-)": "-1028",
      "MTD Grw (+/-)": "-375",
      "LMTD Grw (+/-)": "6261",
      "projection": "-90681",
      "projection_avg_day": "-2925",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Satish",
      "branch_name": "GUNTUR",
      "ftd_target": "1935.48",
      "ftd_achieved": -18168,
      "mtd_target": "48387.00",
      "mtd_achieved": -438298,
      "lmtd_achieved": -264983,
      "lmtd_target": "19354.80",
      "month_target": 60000,
      "FTD Grw (+/-)": "-1039",
      "MTD Grw (+/-)": "-1006",
      "LMTD Grw (+/-)": "-1469",
      "projection": "-543490",
      "projection_avg_day": "-17532",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Satish",
      "branch_name": "GUNTUR2",
      "ftd_target": "1193.55",
      "ftd_achieved": -4812,
      "mtd_target": "29838.75",
      "mtd_achieved": -193431,
      "lmtd_achieved": -144654,
      "lmtd_target": "11935.50",
      "month_target": 37000,
      "FTD Grw (+/-)": "-503",
      "MTD Grw (+/-)": "-748",
      "LMTD Grw (+/-)": "-1312",
      "projection": "-239854",
      "projection_avg_day": "-7737",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Shahbaaz",
      "branch_name": "HANUMAKONDA",
      "ftd_target": "2193.55",
      "ftd_achieved": -13278,
      "mtd_target": "54838.75",
      "mtd_achieved": -179589,
      "lmtd_achieved": -38277,
      "lmtd_target": "21935.50",
      "month_target": 68000,
      "FTD Grw (+/-)": "-705",
      "MTD Grw (+/-)": "-427",
      "LMTD Grw (+/-)": "-274",
      "projection": "-222690",
      "projection_avg_day": "-7184",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Shahbaaz",
      "branch_name": "JANGAON",
      "ftd_target": "2096.77",
      "ftd_achieved": 897,
      "mtd_target": "52419.25",
      "mtd_achieved": -40291,
      "lmtd_achieved": 7622,
      "lmtd_target": "20967.70",
      "month_target": 65000,
      "FTD Grw (+/-)": "-57",
      "MTD Grw (+/-)": "-177",
      "LMTD Grw (+/-)": "-64",
      "projection": "-49961",
      "projection_avg_day": "-1612",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Suresh",
      "branch_name": "JAGTIAL",
      "ftd_target": "2903.23",
      "ftd_achieved": -4650,
      "mtd_target": "72580.75",
      "mtd_achieved": -53333,
      "lmtd_achieved": 152510,
      "lmtd_target": "29032.30",
      "month_target": 90000,
      "FTD Grw (+/-)": "-260",
      "MTD Grw (+/-)": "-173",
      "LMTD Grw (+/-)": "425",
      "projection": "-66133",
      "projection_avg_day": "-2133",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Raghav",
      "branch_name": "KALYANADURGAM",
      "ftd_target": "4870.97",
      "ftd_achieved": 488,
      "mtd_target": "121774.25",
      "mtd_achieved": -1752,
      "lmtd_achieved": 143319,
      "lmtd_target": "48709.70",
      "month_target": 151000,
      "FTD Grw (+/-)": "-90",
      "MTD Grw (+/-)": "-101",
      "LMTD Grw (+/-)": "194",
      "projection": "-2172",
      "projection_avg_day": "-70",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Raghav",
      "branch_name": "KADIRI",
      "ftd_target": "1677.42",
      "ftd_achieved": -8034,
      "mtd_target": "41935.50",
      "mtd_achieved": -112793,
      "lmtd_achieved": 40008,
      "lmtd_target": "16774.20",
      "month_target": 52000,
      "FTD Grw (+/-)": "-579",
      "MTD Grw (+/-)": "-369",
      "LMTD Grw (+/-)": "139",
      "projection": "-139863",
      "projection_avg_day": "-4512",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Platinum",
      "asm": "Hanumanth",
      "branch_name": "KUKATPALLY",
      "ftd_target": "4870.97",
      "ftd_achieved": 2646,
      "mtd_target": "121774.25",
      "mtd_achieved": -298206,
      "lmtd_achieved": 225935,
      "lmtd_target": "48709.70",
      "month_target": 151000,
      "FTD Grw (+/-)": "-46",
      "MTD Grw (+/-)": "-345",
      "LMTD Grw (+/-)": "364",
      "projection": "-369775",
      "projection_avg_day": "-11928",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Chary",
      "branch_name": "KHARMANGHAT",
      "ftd_target": "2322.58",
      "ftd_achieved": -12227,
      "mtd_target": "58064.50",
      "mtd_achieved": -236859,
      "lmtd_achieved": -188128,
      "lmtd_target": "23225.80",
      "month_target": 72000,
      "FTD Grw (+/-)": "-626",
      "MTD Grw (+/-)": "-508",
      "LMTD Grw (+/-)": "-910",
      "projection": "-293705",
      "projection_avg_day": "-9474",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Dattu",
      "branch_name": "KHAMMAM",
      "ftd_target": "903.23",
      "ftd_achieved": -8064,
      "mtd_target": "22580.75",
      "mtd_achieved": -199973,
      "lmtd_achieved": -23120,
      "lmtd_target": "9032.30",
      "month_target": 28000,
      "FTD Grw (+/-)": "-993",
      "MTD Grw (+/-)": "-986",
      "LMTD Grw (+/-)": "-356",
      "projection": "-247967",
      "projection_avg_day": "-7999",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Dattu",
      "branch_name": "KHAMMAM 2",
      "ftd_target": "903.23",
      "ftd_achieved": -10831,
      "mtd_target": "22580.75",
      "mtd_achieved": -220441,
      "lmtd_achieved": 191130,
      "lmtd_target": "9032.30",
      "month_target": 28000,
      "FTD Grw (+/-)": "-1299",
      "MTD Grw (+/-)": "-1076",
      "LMTD Grw (+/-)": "2016",
      "projection": "-273347",
      "projection_avg_day": "-8818",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Kiran",
      "branch_name": "KUPPAM",
      "ftd_target": "3387.10",
      "ftd_achieved": 9242,
      "mtd_target": "84677.50",
      "mtd_achieved": 62929,
      "lmtd_achieved": 224247,
      "lmtd_target": "33871.00",
      "month_target": 105000,
      "FTD Grw (+/-)": "173",
      "MTD Grw (+/-)": "-26",
      "LMTD Grw (+/-)": "562",
      "projection": "78032",
      "projection_avg_day": "2517",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Hanumanth",
      "branch_name": "KHARKHANA",
      "ftd_target": "1774.19",
      "ftd_achieved": -3012,
      "mtd_target": "44354.75",
      "mtd_achieved": -128919,
      "lmtd_achieved": -141,
      "lmtd_target": "17741.90",
      "month_target": 55000,
      "FTD Grw (+/-)": "-270",
      "MTD Grw (+/-)": "-391",
      "LMTD Grw (+/-)": "-101",
      "projection": "-159860",
      "projection_avg_day": "-5157",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Suresh",
      "branch_name": "KARIMNAGAR",
      "ftd_target": "5612.90",
      "ftd_achieved": -2679,
      "mtd_target": "140322.50",
      "mtd_achieved": -163911,
      "lmtd_achieved": 144299,
      "lmtd_target": "56129.00",
      "month_target": 174000,
      "FTD Grw (+/-)": "-148",
      "MTD Grw (+/-)": "-217",
      "LMTD Grw (+/-)": "157",
      "projection": "-203250",
      "projection_avg_day": "-6556",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Platinum",
      "asm": "Raghav",
      "branch_name": "KURNOOL",
      "ftd_target": "6774.19",
      "ftd_achieved": -14204,
      "mtd_target": "169354.75",
      "mtd_achieved": -115311,
      "lmtd_achieved": 304666,
      "lmtd_target": "67741.90",
      "month_target": 210000,
      "FTD Grw (+/-)": "-310",
      "MTD Grw (+/-)": "-168",
      "LMTD Grw (+/-)": "350",
      "projection": "-142986",
      "projection_avg_day": "-4612",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Shahbaaz",
      "branch_name": "KAZIPET",
      "ftd_target": "2354.84",
      "ftd_achieved": 11773,
      "mtd_target": "58871.00",
      "mtd_achieved": 39018,
      "lmtd_achieved": 209935,
      "lmtd_target": "23548.40",
      "month_target": 73000,
      "FTD Grw (+/-)": "400",
      "MTD Grw (+/-)": "-34",
      "LMTD Grw (+/-)": "792",
      "projection": "48382",
      "projection_avg_day": "1561",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Dattu",
      "branch_name": "LANGERHOUSE 2",
      "ftd_target": "1838.71",
      "ftd_achieved": -10616,
      "mtd_target": "45967.75",
      "mtd_achieved": -190648,
      "lmtd_achieved": -109545,
      "lmtd_target": "18387.10",
      "month_target": 57000,
      "FTD Grw (+/-)": "-677",
      "MTD Grw (+/-)": "-515",
      "LMTD Grw (+/-)": "-696",
      "projection": "-236404",
      "projection_avg_day": "-7626",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Kiran",
      "branch_name": "MADANAPALLI",
      "ftd_target": "3903.23",
      "ftd_achieved": 5341,
      "mtd_target": "97580.75",
      "mtd_achieved": -82878,
      "lmtd_achieved": 229008,
      "lmtd_target": "39032.30",
      "month_target": 121000,
      "FTD Grw (+/-)": "37",
      "MTD Grw (+/-)": "-185",
      "LMTD Grw (+/-)": "487",
      "projection": "-102769",
      "projection_avg_day": "-3315",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Hanumanth",
      "branch_name": "MADHAPUR",
      "ftd_target": "1548.39",
      "ftd_achieved": -18823,
      "mtd_target": "38709.75",
      "mtd_achieved": -230227,
      "lmtd_achieved": 194247,
      "lmtd_target": "15483.90",
      "month_target": 48000,
      "FTD Grw (+/-)": "-1316",
      "MTD Grw (+/-)": "-695",
      "LMTD Grw (+/-)": "1155",
      "projection": "-285481",
      "projection_avg_day": "-9209",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Hanumanth",
      "branch_name": "MAHABUBNAGAR",
      "ftd_target": "6612.90",
      "ftd_achieved": 7147,
      "mtd_target": "165322.50",
      "mtd_achieved": -111844,
      "lmtd_achieved": 110355,
      "lmtd_target": "66129.00",
      "month_target": 205000,
      "FTD Grw (+/-)": "8",
      "MTD Grw (+/-)": "-168",
      "LMTD Grw (+/-)": "67",
      "projection": "-138687",
      "projection_avg_day": "-4474",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Chary",
      "branch_name": "MALKAJGIRI",
      "ftd_target": "3161.29",
      "ftd_achieved": -4480,
      "mtd_target": "79032.25",
      "mtd_achieved": -22970,
      "lmtd_achieved": 141555,
      "lmtd_target": "31612.90",
      "month_target": 98000,
      "FTD Grw (+/-)": "-242",
      "MTD Grw (+/-)": "-129",
      "LMTD Grw (+/-)": "348",
      "projection": "-28483",
      "projection_avg_day": "-919",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Satish",
      "branch_name": "MACHILIPATNAM",
      "ftd_target": "806.45",
      "ftd_achieved": -5269,
      "mtd_target": "20161.25",
      "mtd_achieved": -307159,
      "lmtd_achieved": -162934,
      "lmtd_target": "8064.50",
      "month_target": 25000,
      "FTD Grw (+/-)": "-753",
      "MTD Grw (+/-)": "-1624",
      "LMTD Grw (+/-)": "-2120",
      "projection": "-380877",
      "projection_avg_day": "-12286",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Prasad",
      "branch_name": "MVP COLONY",
      "ftd_target": "1419.35",
      "ftd_achieved": -10205,
      "mtd_target": "35483.75",
      "mtd_achieved": -150971,
      "lmtd_achieved": 6644,
      "lmtd_target": "14193.50",
      "month_target": 44000,
      "FTD Grw (+/-)": "-819",
      "MTD Grw (+/-)": "-525",
      "LMTD Grw (+/-)": "-53",
      "projection": "-187204",
      "projection_avg_day": "-6039",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Raghav",
      "branch_name": "NANDYALA",
      "ftd_target": "1451.61",
      "ftd_achieved": -6782,
      "mtd_target": "36290.25",
      "mtd_achieved": -123519,
      "lmtd_achieved": 63882,
      "lmtd_target": "14516.10",
      "month_target": 45000,
      "FTD Grw (+/-)": "-567",
      "MTD Grw (+/-)": "-440",
      "LMTD Grw (+/-)": "340",
      "projection": "-153164",
      "projection_avg_day": "-4941",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Dattu",
      "branch_name": "NALGONDA",
      "ftd_target": "2419.35",
      "ftd_achieved": 568,
      "mtd_target": "60483.75",
      "mtd_achieved": -46469,
      "lmtd_achieved": 240403,
      "lmtd_target": "24193.50",
      "month_target": 75000,
      "FTD Grw (+/-)": "-77",
      "MTD Grw (+/-)": "-177",
      "LMTD Grw (+/-)": "894",
      "projection": "-57622",
      "projection_avg_day": "-1859",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Suresh",
      "branch_name": "NIRMAL",
      "ftd_target": "1612.90",
      "ftd_achieved": -6592,
      "mtd_target": "40322.50",
      "mtd_achieved": -105565,
      "lmtd_achieved": -7673,
      "lmtd_target": "16129.00",
      "month_target": 50000,
      "FTD Grw (+/-)": "-509",
      "MTD Grw (+/-)": "-362",
      "LMTD Grw (+/-)": "-148",
      "projection": "-130901",
      "projection_avg_day": "-4223",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Shahbaaz",
      "branch_name": "NARSAMPET",
      "ftd_target": "4645.16",
      "ftd_achieved": 7737,
      "mtd_target": "116129.00",
      "mtd_achieved": 88380,
      "lmtd_achieved": 200620,
      "lmtd_target": "46451.60",
      "month_target": 144000,
      "FTD Grw (+/-)": "67",
      "MTD Grw (+/-)": "-24",
      "LMTD Grw (+/-)": "332",
      "projection": "109591",
      "projection_avg_day": "3535",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Platinum",
      "asm": "Kiran",
      "branch_name": "ONGOLE",
      "ftd_target": "806.45",
      "ftd_achieved": -18584,
      "mtd_target": "20161.25",
      "mtd_achieved": -511978,
      "lmtd_achieved": -15643,
      "lmtd_target": "8064.50",
      "month_target": 25000,
      "FTD Grw (+/-)": "-2404",
      "MTD Grw (+/-)": "-2639",
      "LMTD Grw (+/-)": "-294",
      "projection": "-634853",
      "projection_avg_day": "-20479",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Kiran",
      "branch_name": "PALAMANER",
      "ftd_target": "1935.48",
      "ftd_achieved": 640,
      "mtd_target": "48387.00",
      "mtd_achieved": -66927,
      "lmtd_achieved": 34057,
      "lmtd_target": "19354.80",
      "month_target": 60000,
      "FTD Grw (+/-)": "-67",
      "MTD Grw (+/-)": "-238",
      "LMTD Grw (+/-)": "76",
      "projection": "-82989",
      "projection_avg_day": "-2677",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Dattu",
      "branch_name": "PALAVANCHA",
      "ftd_target": "1064.52",
      "ftd_achieved": -7468,
      "mtd_target": "26613.00",
      "mtd_achieved": -116369,
      "lmtd_achieved": -3629,
      "lmtd_target": "10645.20",
      "month_target": 33000,
      "FTD Grw (+/-)": "-802",
      "MTD Grw (+/-)": "-537",
      "LMTD Grw (+/-)": "-134",
      "projection": "-144298",
      "projection_avg_day": "-4655",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Kiran",
      "branch_name": "RAYACHOTI",
      "ftd_target": "2000.00",
      "ftd_achieved": 19473,
      "mtd_target": "50000.00",
      "mtd_achieved": 167355,
      "lmtd_achieved": 366656,
      "lmtd_target": "20000.00",
      "month_target": 62000,
      "FTD Grw (+/-)": "874",
      "MTD Grw (+/-)": "235",
      "LMTD Grw (+/-)": "1733",
      "projection": "207520",
      "projection_avg_day": "6694",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Prasad",
      "branch_name": "RAJAMUNDRY",
      "ftd_target": "4193.55",
      "ftd_achieved": 4523,
      "mtd_target": "104838.75",
      "mtd_achieved": -36111,
      "lmtd_achieved": 310019,
      "lmtd_target": "41935.50",
      "month_target": 130000,
      "FTD Grw (+/-)": "8",
      "MTD Grw (+/-)": "-134",
      "LMTD Grw (+/-)": "639",
      "projection": "-44778",
      "projection_avg_day": "-1444",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Chary",
      "branch_name": "RAMANTHAPUR",
      "ftd_target": "3774.19",
      "ftd_achieved": -9754,
      "mtd_target": "94354.75",
      "mtd_achieved": -122342,
      "lmtd_achieved": 33894,
      "lmtd_target": "37741.90",
      "month_target": 117000,
      "FTD Grw (+/-)": "-358",
      "MTD Grw (+/-)": "-230",
      "LMTD Grw (+/-)": "-10",
      "projection": "-151704",
      "projection_avg_day": "-4894",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Chary",
      "branch_name": "RTC X ROAD",
      "ftd_target": "4580.65",
      "ftd_achieved": 2065,
      "mtd_target": "114516.25",
      "mtd_achieved": -21234,
      "lmtd_achieved": 208110,
      "lmtd_target": "45806.50",
      "month_target": 142000,
      "FTD Grw (+/-)": "-55",
      "MTD Grw (+/-)": "-119",
      "LMTD Grw (+/-)": "354",
      "projection": "-26330",
      "projection_avg_day": "-849",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Hanumanth",
      "branch_name": "SUCHITRA",
      "ftd_target": null,
      "ftd_achieved": -19208,
      "mtd_target": null,
      "mtd_achieved": -486097,
      "lmtd_achieved": -272339,
      "lmtd_target": null,
      "month_target": 0,
      "FTD Grw (+/-)": "-100",
      "MTD Grw (+/-)": "-100",
      "LMTD Grw (+/-)": "-100",
      "projection": "-602760",
      "projection_avg_day": "-19444",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Suresh",
      "branch_name": "SIDDIPET",
      "ftd_target": "2870.97",
      "ftd_achieved": 4629,
      "mtd_target": "71774.25",
      "mtd_achieved": -119832,
      "lmtd_achieved": -2347,
      "lmtd_target": "28709.70",
      "month_target": 89000,
      "FTD Grw (+/-)": "61",
      "MTD Grw (+/-)": "-267",
      "LMTD Grw (+/-)": "-108",
      "projection": "-148592",
      "projection_avg_day": "-4793",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Hanumanth",
      "branch_name": "S.D.ROAD",
      "ftd_target": "677.42",
      "ftd_achieved": -827,
      "mtd_target": "16935.50",
      "mtd_achieved": -222938,
      "lmtd_achieved": -59576,
      "lmtd_target": "6774.20",
      "month_target": 21000,
      "FTD Grw (+/-)": "-222",
      "MTD Grw (+/-)": "-1416",
      "LMTD Grw (+/-)": "-979",
      "projection": "-276443",
      "projection_avg_day": "-8918",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Hanumanth",
      "branch_name": "SHADNAGAR",
      "ftd_target": "4129.03",
      "ftd_achieved": -4433,
      "mtd_target": "103225.75",
      "mtd_achieved": -75122,
      "lmtd_achieved": 167685,
      "lmtd_target": "41290.30",
      "month_target": 128000,
      "FTD Grw (+/-)": "-207",
      "MTD Grw (+/-)": "-173",
      "LMTD Grw (+/-)": "306",
      "projection": "-93151",
      "projection_avg_day": "-3005",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Hanumanth",
      "branch_name": "SHAPUR",
      "ftd_target": "1903.23",
      "ftd_achieved": -5977,
      "mtd_target": "47580.75",
      "mtd_achieved": -81652,
      "lmtd_achieved": -28779,
      "lmtd_target": "19032.30",
      "month_target": 59000,
      "FTD Grw (+/-)": "-414",
      "MTD Grw (+/-)": "-272",
      "LMTD Grw (+/-)": "-251",
      "projection": "-101248",
      "projection_avg_day": "-3266",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Prasad",
      "branch_name": "SRIKAKULAM",
      "ftd_target": "1000.00",
      "ftd_achieved": -9677,
      "mtd_target": "25000.00",
      "mtd_achieved": -262834,
      "lmtd_achieved": -70058,
      "lmtd_target": "10000.00",
      "month_target": 31000,
      "FTD Grw (+/-)": "-1068",
      "MTD Grw (+/-)": "-1151",
      "LMTD Grw (+/-)": "-801",
      "projection": "-325914",
      "projection_avg_day": "-10513",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Hanumanth",
      "branch_name": "SHAMSHABAD",
      "ftd_target": "3387.10",
      "ftd_achieved": -553,
      "mtd_target": "84677.50",
      "mtd_achieved": -128796,
      "lmtd_achieved": 81995,
      "lmtd_target": "33871.00",
      "month_target": 105000,
      "FTD Grw (+/-)": "-116",
      "MTD Grw (+/-)": "-252",
      "LMTD Grw (+/-)": "142",
      "projection": "-159707",
      "projection_avg_day": "-5152",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Dattu",
      "branch_name": "SANGAREDDY",
      "ftd_target": "1935.48",
      "ftd_achieved": -8974,
      "mtd_target": "48387.00",
      "mtd_achieved": -157962,
      "lmtd_achieved": -122018,
      "lmtd_target": "19354.80",
      "month_target": 60000,
      "FTD Grw (+/-)": "-564",
      "MTD Grw (+/-)": "-426",
      "LMTD Grw (+/-)": "-730",
      "projection": "-195873",
      "projection_avg_day": "-6318",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Platinum",
      "asm": "Dattu",
      "branch_name": "S.R.NAGAR",
      "ftd_target": "1290.32",
      "ftd_achieved": 7120,
      "mtd_target": "32258.00",
      "mtd_achieved": -140354,
      "lmtd_achieved": 117702,
      "lmtd_target": "12903.20",
      "month_target": 40000,
      "FTD Grw (+/-)": "452",
      "MTD Grw (+/-)": "-535",
      "LMTD Grw (+/-)": "812",
      "projection": "-174039",
      "projection_avg_day": "-5614",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Chary",
      "branch_name": "SAROORNAGAR",
      "ftd_target": "4225.81",
      "ftd_achieved": -4468,
      "mtd_target": "105645.25",
      "mtd_achieved": -225809,
      "lmtd_achieved": -33858,
      "lmtd_target": "42258.10",
      "month_target": 131000,
      "FTD Grw (+/-)": "-206",
      "MTD Grw (+/-)": "-314",
      "LMTD Grw (+/-)": "-180",
      "projection": "-280003",
      "projection_avg_day": "-9032",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Dattu",
      "branch_name": "SURYAPET",
      "ftd_target": "1000.00",
      "ftd_achieved": -3329,
      "mtd_target": "25000.00",
      "mtd_achieved": -103991,
      "lmtd_achieved": -109780,
      "lmtd_target": "10000.00",
      "month_target": 31000,
      "FTD Grw (+/-)": "-433",
      "MTD Grw (+/-)": "-516",
      "LMTD Grw (+/-)": "-1198",
      "projection": "-128949",
      "projection_avg_day": "-4160",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Chary",
      "branch_name": "SANTOSHNAGAR",
      "ftd_target": "4129.03",
      "ftd_achieved": -9257,
      "mtd_target": "103225.75",
      "mtd_achieved": -150868,
      "lmtd_achieved": -5497,
      "lmtd_target": "41290.30",
      "month_target": 128000,
      "FTD Grw (+/-)": "-324",
      "MTD Grw (+/-)": "-246",
      "LMTD Grw (+/-)": "-113",
      "projection": "-187076",
      "projection_avg_day": "-6035",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Prasad",
      "branch_name": "TADEPALLIGUDEM",
      "ftd_target": "1967.74",
      "ftd_achieved": -5331,
      "mtd_target": "49193.50",
      "mtd_achieved": -215276,
      "lmtd_achieved": -12694,
      "lmtd_target": "19677.40",
      "month_target": 61000,
      "FTD Grw (+/-)": "-371",
      "MTD Grw (+/-)": "-538",
      "LMTD Grw (+/-)": "-165",
      "projection": "-266942",
      "projection_avg_day": "-8611",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Raghav",
      "branch_name": "TADIPATRI",
      "ftd_target": "1935.48",
      "ftd_achieved": -1158,
      "mtd_target": "48387.00",
      "mtd_achieved": -47935,
      "lmtd_achieved": 159466,
      "lmtd_target": "19354.80",
      "month_target": 60000,
      "FTD Grw (+/-)": "-160",
      "MTD Grw (+/-)": "-199",
      "LMTD Grw (+/-)": "724",
      "projection": "-59439",
      "projection_avg_day": "-1917",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Prasad",
      "branch_name": "TANUKU",
      "ftd_target": "1032.26",
      "ftd_achieved": -12649,
      "mtd_target": "25806.50",
      "mtd_achieved": -179264,
      "lmtd_achieved": 68283,
      "lmtd_target": "10322.60",
      "month_target": 32000,
      "FTD Grw (+/-)": "-1325",
      "MTD Grw (+/-)": "-795",
      "LMTD Grw (+/-)": "561",
      "projection": "-222287",
      "projection_avg_day": "-7171",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Satish",
      "branch_name": "TENALI",
      "ftd_target": "1903.23",
      "ftd_achieved": -8801,
      "mtd_target": "47580.75",
      "mtd_achieved": -144127,
      "lmtd_achieved": 59593,
      "lmtd_target": "19032.30",
      "month_target": 59000,
      "FTD Grw (+/-)": "-562",
      "MTD Grw (+/-)": "-403",
      "LMTD Grw (+/-)": "213",
      "projection": "-178717",
      "projection_avg_day": "-5765",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Kiran",
      "branch_name": "TIRUPATHI",
      "ftd_target": "387.10",
      "ftd_achieved": -18122,
      "mtd_target": "9677.50",
      "mtd_achieved": -347013,
      "lmtd_achieved": -272138,
      "lmtd_target": "3871.00",
      "month_target": 12000,
      "FTD Grw (+/-)": "-4781",
      "MTD Grw (+/-)": "-3686",
      "LMTD Grw (+/-)": "-7130",
      "projection": "-430296",
      "projection_avg_day": "-13881",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Chary",
      "branch_name": "UPPAL",
      "ftd_target": "4354.84",
      "ftd_achieved": -11698,
      "mtd_target": "108871.00",
      "mtd_achieved": -107893,
      "lmtd_achieved": 97430,
      "lmtd_target": "43548.40",
      "month_target": 135000,
      "FTD Grw (+/-)": "-369",
      "MTD Grw (+/-)": "-199",
      "LMTD Grw (+/-)": "124",
      "projection": "-133787",
      "projection_avg_day": "-4316",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Titanium",
      "asm": "Satish",
      "branch_name": "VIJAYAWADA 1",
      "ftd_target": "4354.84",
      "ftd_achieved": -39817,
      "mtd_target": "108871.00",
      "mtd_achieved": -910512,
      "lmtd_achieved": -1202,
      "lmtd_target": "43548.40",
      "month_target": 135000,
      "FTD Grw (+/-)": "-1014",
      "MTD Grw (+/-)": "-936",
      "LMTD Grw (+/-)": "-103",
      "projection": "-1129035",
      "projection_avg_day": "-36420",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Satish",
      "branch_name": "VIJAYAWADA 2",
      "ftd_target": "2935.48",
      "ftd_achieved": -12354,
      "mtd_target": "73387.00",
      "mtd_achieved": -411493,
      "lmtd_achieved": -297351,
      "lmtd_target": "29354.80",
      "month_target": 91000,
      "FTD Grw (+/-)": "-521",
      "MTD Grw (+/-)": "-661",
      "LMTD Grw (+/-)": "-1113",
      "projection": "-510251",
      "projection_avg_day": "-16460",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Satish",
      "branch_name": "VIJAYAWADA 3",
      "ftd_target": "2129.03",
      "ftd_achieved": -11536,
      "mtd_target": "53225.75",
      "mtd_achieved": -408433,
      "lmtd_achieved": -282541,
      "lmtd_target": "21290.30",
      "month_target": 66000,
      "FTD Grw (+/-)": "-642",
      "MTD Grw (+/-)": "-867",
      "LMTD Grw (+/-)": "-1427",
      "projection": "-506457",
      "projection_avg_day": "-16337",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Satish",
      "branch_name": "VIJAYAWADA 4",
      "ftd_target": "1451.61",
      "ftd_achieved": -1104,
      "mtd_target": "36290.25",
      "mtd_achieved": -217900,
      "lmtd_achieved": 42882,
      "lmtd_target": "14516.10",
      "month_target": 45000,
      "FTD Grw (+/-)": "-176",
      "MTD Grw (+/-)": "-700",
      "LMTD Grw (+/-)": "195",
      "projection": "-270196",
      "projection_avg_day": "-8716",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Chary",
      "branch_name": "VANASTALIPURAM",
      "ftd_target": "4612.90",
      "ftd_achieved": -7030,
      "mtd_target": "115322.50",
      "mtd_achieved": -156655,
      "lmtd_achieved": -8964,
      "lmtd_target": "46129.00",
      "month_target": 143000,
      "FTD Grw (+/-)": "-252",
      "MTD Grw (+/-)": "-236",
      "LMTD Grw (+/-)": "-119",
      "projection": "-194252",
      "projection_avg_day": "-6266",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Gold",
      "asm": "Prasad",
      "branch_name": "VIZIANAGARAM",
      "ftd_target": "2387.10",
      "ftd_achieved": -12019,
      "mtd_target": "59677.50",
      "mtd_achieved": -168802,
      "lmtd_achieved": 111684,
      "lmtd_target": "23871.00",
      "month_target": 74000,
      "FTD Grw (+/-)": "-603",
      "MTD Grw (+/-)": "-383",
      "LMTD Grw (+/-)": "368",
      "projection": "-209314",
      "projection_avg_day": "-6752",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Shahbaaz",
      "branch_name": "WARANGAL",
      "ftd_target": "2290.32",
      "ftd_achieved": -10864,
      "mtd_target": "57258.00",
      "mtd_achieved": -220908,
      "lmtd_achieved": -66056,
      "lmtd_target": "22903.20",
      "month_target": 71000,
      "FTD Grw (+/-)": "-574",
      "MTD Grw (+/-)": "-486",
      "LMTD Grw (+/-)": "-388",
      "projection": "-273926",
      "projection_avg_day": "-8836",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Platinum",
      "asm": "Kiran",
      "branch_name": "TIRUPATHI 2",
      "ftd_target": "8064.52",
      "ftd_achieved": -5053,
      "mtd_target": "201613.00",
      "mtd_achieved": -370227,
      "lmtd_achieved": -233446,
      "lmtd_target": "80645.20",
      "month_target": 250000,
      "FTD Grw (+/-)": "-163",
      "MTD Grw (+/-)": "-284",
      "LMTD Grw (+/-)": "-389",
      "projection": "-459081",
      "projection_avg_day": "-14809",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Gold",
      "asm": "Suresh",
      "branch_name": "NIZAMABAD 2",
      "ftd_target": "3580.65",
      "ftd_achieved": -13386,
      "mtd_target": "89516.25",
      "mtd_achieved": -296369,
      "lmtd_achieved": -222875,
      "lmtd_target": "35806.50",
      "month_target": 111000,
      "FTD Grw (+/-)": "-474",
      "MTD Grw (+/-)": "-431",
      "LMTD Grw (+/-)": "-722",
      "projection": "-367498",
      "projection_avg_day": "-11855",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "AP",
      "category": "Silver",
      "asm": "Prasad",
      "branch_name": "TUNI",
      "ftd_target": "2580.65",
      "ftd_achieved": 2575,
      "mtd_target": "64516.25",
      "mtd_achieved": -10537,
      "lmtd_achieved": 177838,
      "lmtd_target": "25806.50",
      "month_target": 80000,
      "FTD Grw (+/-)": "0",
      "MTD Grw (+/-)": "-116",
      "LMTD Grw (+/-)": "589",
      "projection": "-13066",
      "projection_avg_day": "-421",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    },
    {
      "region": "TG",
      "category": "Silver",
      "asm": "Suresh",
      "branch_name": "PEDDAPALLI",
      "ftd_target": "3548.39",
      "ftd_achieved": 5307,
      "mtd_target": "88709.75",
      "mtd_achieved": 38546,
      "lmtd_achieved": -193548,
      "lmtd_target": "35483.90",
      "month_target": 110000,
      "FTD Grw (+/-)": "50",
      "MTD Grw (+/-)": "-57",
      "LMTD Grw (+/-)": "-645",
      "projection": "47797",
      "projection_avg_day": "1542",
      "transaction_date": "2024-11-25T00:00:00.000Z"
    }
  ]);
  console.log("reportsData", reportsData)
  const scrollContainerRef = useRef(null);
  const [isTop, setIsTop] = useState(true);
  const [isBottom, setIsBottom] = useState(false);
  const [scrollinState, setScrollingState] = useState();
  const current_time = new Date("15:48:21.69756+05:30")
  const current_date = "2024-11-29T00:00:00.000Z"


  // Scroll up by a small amount
  const scrollTop = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        top: -100,
        behavior: 'smooth'
      });
    }
  };

  const getTime = (time) => {
    const timeStr = time.split('.')?.[0]
    // Create a Date object using your time string (UTC format)
    const date = new Date(`1970-01-01T${timeStr}Z`); // 'Z' for UTC
    // Now convert the time to a 12-hour format using toLocaleTimeString()
    const localTime12Hour = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,      // Use 12-hour format
      timeZone: 'UTC'    // Ensure the time is treated as UTC
    });

    console.log(localTime12Hour);
    return localTime12Hour
  }

  const formatAmount = (val) => {
    const amount = val;
    const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const formattedAmount = formatter.format(amount);
    return formattedAmount
    console.log(formattedAmount);
  }

  // Scroll down by a small amount
  const scrollBottom = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        top: 100,
        behavior: 'smooth'
      });
      setScrollingState(scrollContainerRef)
    }
  };

  const scrollRight=()=>{
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 100, // Use 'left' for horizontal scrolling
        behavior: 'smooth'
      });
      setScrollingState(scrollContainerRef);
    }
  }
  const scrollLeft=()=>{
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -100, // Use 'left' for horizontal scrolling
        behavior: 'smooth'
      });
      setScrollingState(scrollContainerRef);
    }
  }

  // Update button states based on scroll position
  const updateButtonState = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      setIsTop(container.scrollTop === 0);
      setIsBottom(container.scrollHeight - container.scrollTop === container.clientHeight);
    }
  };

  // Add event listener to check scroll position
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('scroll', updateButtonState);
    }
    return () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.removeEventListener('scroll', updateButtonState);
      }
    };
  }, []);

  // Handle changes in a cell's value
  const handleChange = (e, rowIdx, colIdx) => {
    const newCells = [...cells];
    newCells[rowIdx][colIdx] = e.target.value;
    setCells(newCells);
  };

  useEffect(() => {
    getReportsData()
  }, [])

  useEffect(() => {
    socket.on("connect", () => {
      console.log(socket.id, "connetcted");
    });
    let localUid=localStorage.getItem('uuid');

    socket.on('scroll', (data) => {
      console.log("data",data)
      if(data?.uuid==JSON.parse(localUid)){
        if (data.type == "up") scrollTop()
        if (data.type == "down") scrollBottom()
        if (data.type == "right") scrollRight();
        if (data.type == "left") scrollLeft()
      }
    })
    socket.on("error", (error) => {
      console.log("erorrr")
      // console.log(socket.id,"dissss"); 
    });
    socket.on("disconnect", () => {
      console.log(socket.id, "dissss");
    });
    return () => {
      socket.off("message");
    };

  }, []);

  const getReportsData = async () => {
    if (!data) return
    let statevalue = data?.state?.value || 0;
    let asmValue = data?.asm?.value || 0;
    let storeValue = data?.store?.value || 0
    if (data?.state?.value == "All") {
      statevalue = 0;
      asmValue = 0;
      storeValue = 0;
    }
    if (data?.state?.value && (!storeValue && !asmValue)) {
      asmValue = 0;
      storeValue = 0;
    }
    if (data?.store?.value) {
      statevalue = 0;
      asmValue = 0;
    }
    if (data?.asm?.value) {
      statevalue = 0;
    }
    let payload = {
      statehead: statevalue,
      asm: asmValue,
      store: storeValue,
    };

    let response = await fetch(`${BASE_URL}/api/tvDashboard/profitXLSheetData`);
    let result = await response.json()
    setReportsData(result)
  }
  let re = {
    "region": "TG",
    "category": "Gold",
    "asm": "Suresh",
    "branch_name": "ADILABAD",
    "ftd_target": "3612.90",
    "ftd_achieved": 6573,
    "mtd_target": "90322.50",
    "mtd_achieved": 3713,
    "lmtd_achieved": 312995,
    "lmtd_target": "36129.00",
    "month_target": 112000,
    "FTD Grw (+/-)": "82",
    "MTD Grw (+/-)": "-96",
    "LMTD Grw (+/-)": "766",
    "projection": "4604",
    "projection_avg_day": "149",
    "transaction_date": "2024-11-25T00:00:00.000Z"
  }



  const calculateAsmTotal = (data, asm, isGrandTotal, showSpan) => {
    let getTotal = (totalType) => {
      return Math.round(data.map(item => item[totalType]).reduce((a, b) => {
        let value;
        if (b) value = a + parseFloat(b);
        else value = a + 0
        return value
      }, 0))
    }

    const getPercentage = (value1, value2) => {
      let totalTarget = getTotal(value1);
      let totalAchieved = getTotal(value2)
      let percentage = ((totalAchieved - totalTarget) / totalTarget) * 100;
      return percentage
    }
    return <tr className={isGrandTotal ? "grand-total" : "total-cal"}>
      <td colSpan={showSpan ? 4 : 0} className="fs-6 fw-bold">{asm+ " Total"}</td>
      <td>{formatAmount(getTotal("ftd_target"))}</td>
      <td>{formatAmount(getTotal("ftd_achieved"))}</td>
      <td>{Math.trunc(getPercentage("ftd_target", "ftd_achieved"))}%</td>
      <td>{formatAmount(getTotal("mtd_target"))}</td>
      <td>{formatAmount(getTotal("mtd_achieved"))}</td>
      <td>{Math.trunc(getPercentage("mtd_target", "mtd_achieved"))}%</td>
      <td>{formatAmount(getTotal("lmtd_target"))}</td>
      <td>{formatAmount(getTotal("lmtd_achieved"))}</td>
      <td>{Math.trunc(getPercentage("lmtd_target", "lmtd_target"))}%</td>
      <td>{formatAmount(getTotal("month_target"))}</td>
      <td>{formatAmount(getTotal("projection"))}</td>
      <td>{formatAmount(getTotal("projection_avg_day"))}</td>
    </tr>
  }



  const getASMWiseData = (data, type) => {
    let filterASMs;
    if (type == "asm") filterASMs = [...new Set(data.map(item => item.asm))];
    if (type == "category") filterASMs = [...new Set(data.map(item => item.category))];
    let mapping = []
    for (let i of filterASMs) {
      if (type == "asm") mapping.push(calculateAsmTotal(data.filter(item => item.asm == i), i, false, false));
      if (type == "category") mapping.push(calculateAsmTotal(data.filter(item => item.category == i), i, false, false));
    }
    mapping.push(calculateAsmTotal(data, "Grand", false, false))
    return mapping
  }



  const mapReportsData = (data) => {
    let mappingData = []
    for (let i of [...new Set(data.map(item => item.asm))]) {
      mappingData.push(data.filter(item => item.asm == i).map(item => <tr>
        <td>{item.region}</td>
        <td>{item.asm}</td>
        <th>{item.category}</th>
        <td>{item.branch_name}</td>
        <td >{formatAmount(item.ftd_target)}</td>
        <td>{formatAmount(item.ftd_achieved)}</td>
        <td className="grow-amount">{item['FTD Grw (+/-)']}%</td>
        <td>{formatAmount(item.mtd_target)}</td>
        <td>{formatAmount(item.mtd_achieved)}</td>
        <td className="grow-amount">{item["MTD Grw (+/-)"]}%</td>
        <td>{formatAmount(item.lmtd_target)}</td>
        <td>{formatAmount(item.lmtd_achieved)}</td>
        <td className="grow-amount">{item["LMTD Grw (+/-)"]}%</td>
        <td>{formatAmount(item?.month_target)}</td>
        <td>{formatAmount(item.projection)}</td>
        <td>{formatAmount(item.projection_avg_day)}</td>
      </tr>)
      )
      mappingData.push(calculateAsmTotal(data.filter(item => item.asm == i), i, false, true))
    }

    mappingData.push(calculateAsmTotal(data, "Grand", true, true))
    return mappingData
  }



  return (
    <div className="App position-relative">
      {/* Scrollable container */}

      <div ref={scrollContainerRef} style={{ height: '100vh', overflowY: 'auto' }}>
        <div className="d-flex gap-3 ps-tsicky  w-100 align-items-center">
          <img src={happilogo} height={"30px"} width={"30px"}/>
          <p className="fs-6 bg-sync m-0">Last Sync Date and Time:<span className="text-white ms-1">{moment(new Date(reportsData?.[0]?.current_date)).format('ll')}{" "} {getTime(reportsData?.[0]?.current_time)}</span></p>
          <p className="fs-6 m-0 bg-sync">State:<span className="text-white ms-1">{data?.state?.label}</span></p>
          {data?.asm?.label&&<p className="fs-6 m-0 bg-sync">ASM:<span className="text-white ms-1">{data?.asm?.label}</span></p>}
        </div>


        {/* First table (Region-wise) */}
        <table className={`excel-table mt-2 ${((data?.state.label == "TG"||data?.state.label == "AP")&&!data?.asm?.label)&&"mb-5"}`}>
          <thead>
            <tr>
              <th>Region</th>
              <th>ASM</th>
              <th>Category</th>
              <th>Branch</th>
              <th>FTD TGT</th>
              <th>FTD Achi</th>
              <th>FTD%</th>
              <th>MTD TGT</th>
              <th>MTD Achi</th>
              <th>MTD%</th>
              <th>LMTD Target</th>
              <th>LMTD Achieved</th>
              <th>LMTD GROW(+/-)</th>
              <th>PT Target</th>
              <th>Projection</th>
              <th>Projection_avg_day</th>
            </tr>
          </thead>
          <tbody>
            {
              (data?.state.label == "TG" && !data?.asm?.label) && mapReportsData(reportsData.filter(regionItem => regionItem.region === 'TG'))
            }

            {
              (data?.state.label == "TG" && data?.asm?.label) && mapReportsData(reportsData.filter(regionItem => regionItem.region === 'TG').filter(asmItem => asmItem.asm == data?.asm?.label))
            }

            {
              (data?.state.label == "AP" && !data?.asm?.label) && mapReportsData(reportsData.filter(regionItem => regionItem.region === 'AP'))
            }
            {
              (data?.state.label == "AP" && data?.asm?.label) && mapReportsData(reportsData.filter(regionItem => regionItem.region === 'AP').filter(asmItem => asmItem.asm == data?.asm?.label))}
            {
              data?.state?.label == "All" && <>
                {mapReportsData(reportsData.filter(regionItem => regionItem.region === 'TG'))}
                {mapReportsData(reportsData.filter(regionItem => regionItem.region === 'AP'))}
              </>
            }

          </tbody>
        </table>

        {/* Table for showing region wise total */}
        {
          (data?.asm?.label === "All" && (data.state.label == "AP" || data.state.label == "TG"||data.state.label == "All")
          ) && <>
            <h6 className="text-center fw-bold m-0 fs-5 p-3">Region Wise </h6>
            <table className="excel-table">
              <thead>
                <tr>
                  <th>Region</th>
                  <th>FTD TGT</th>
                  <th>FTD Achi</th>
                  <th>FTD%</th>
                  <th>MTD TGT</th>
                  <th>MTD Achi</th>
                  <th>MTD%</th>
                  <th>LMTD Target</th>
                  <th>LMTD Achieved</th>
                  <th>LMTD GROW(+/-)</th>
                  <th>PT Target</th>
                  <th>Projection</th>
                  <th>Projection_avg_day</th>
                </tr>
              </thead>
              <tbody>
                {(data?.state.label == "AP" && (data?.asm?.label == "All" || !data?.asm?.label)) && calculateAsmTotal(reportsData.filter(regionItem => regionItem.region === 'AP'), "AP", true, false)}
                {(data?.state.label == "TG" && (data?.asm?.label == "All" || !data?.asm?.label)) && calculateAsmTotal(reportsData.filter(regionItem => regionItem.region === 'TG'), "TG", true, false)}
                {
                  (data?.state.label == "All" && (data?.asm?.label == "All" || !data?.asm?.label)) && <>
                    {calculateAsmTotal(reportsData.filter(regionItem => regionItem.region === 'AP'), "AP", true, false)}
                    {calculateAsmTotal(reportsData.filter(regionItem => regionItem.region === 'TG'), "TG", true, false)}
                    {(data?.state.label == "TG" && !data?.asm?.label) && calculateAsmTotal(reportsData.filter(regionItem => regionItem.region === 'TG'), "TG", true, false)}
                  </>
                }
              </tbody>
            </table></>
        }


        {/* Table for ASM-wise */}
        {
          (data?.asm?.label === "All" && (data.state.label == "AP" || data.state.label == "TG"||data.state.label == "All")) && <>
            <h6 className="text-center fw-bold m-0 fs-5 p-3">ASM Wise </h6>
            <table className="excel-table">
              <thead>
                <tr>
                  <th>ASM</th>
                  <th>FTD TGT</th>
                  <th>FTD Achi</th>
                  <th>FTD%</th>
                  <th>MTD TGT</th>
                  <th>MTD Achi</th>
                  <th>MTD%</th>
                  <th>LMTD Target</th>
                  <th>LMTD Achieved</th>
                  <th>LMTD GROW(+/-)</th>
                  <th>PT Target</th>
                  <th>Projection</th>
                  <th>Projection_avg_day</th>
                </tr>
              </thead>
              <tbody>

                {data?.state.label == "TG" && getASMWiseData(reportsData.filter(regionItem => regionItem?.region == "TG"), "asm")}
                {data?.state.label == "AP" && getASMWiseData(reportsData.filter(regionItem => regionItem?.region == "AP"), "asm")}
                {data?.state?.label == "All" && getASMWiseData(reportsData, "asm")}

              </tbody>
            </table></>
        }


        {/* Table for Category-wise */}
        {
          (data?.asm?.label === "All" && (data.state.label == "AP" || data.state.label == "TG"|| data.state.label == "All")
          ) && <>
            <h6 className="text-center fw-bold m-0 fs-5 p-3">Category Wise </h6>
            <table className="excel-table mb-5">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>FTD TGT</th>
                  <th>FTD Achi</th>
                  <th>FTD%</th>
                  <th>MTD TGT</th>
                  <th>MTD Achi</th>
                  <th>MTD%</th>
                  <th>LMTD Target</th>  
                  <th>LMTD Achieved</th>
                  <th>LMTD GROW(+/-)</th>
                  <th>PT Target</th>
                  <th>Projection</th>
                  <th>Projection_avg_day</th>
                </tr>
              </thead>
              <tbody>
                {data?.state.label == "TG" && getASMWiseData(reportsData.filter(regionItem => regionItem?.region == "TG"), "category")}
                {data?.state.label == "AP" && getASMWiseData(reportsData.filter(regionItem => regionItem?.region == "AP"), "category")}
                {data?.state.label == "All" && getASMWiseData(reportsData, "category")}
              </tbody>
            </table></>
        }


      </div>
    </div>
  );
};

export default Reports;
